// Path: src/utils/constants.js
export const APP_NAME = "Wish Whisper";
export const APP_DESCRIPTION = "A place to share your wishes with the world";
